module.exports = __webpack_public_path__ + "static/img/main-bg.ac67ff4d.png";